<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import IconCheck from '~icons/material-symbols/check'

const { t } = useI18n()
</script>

<template>
  <span class="condition-check" aria-hidden="true">
    <IconCheck class="condition-check-icon" />
  </span>
  <span class="sr-only">
    {{ t('my_wallet.receiving_model.card.requirement_status_label', { status: t('my_wallet.receiving_model.card.requirement_status.done') }) }}
  </span>
</template>

<style scoped lang="scss">
.condition-check {
  @apply flex items-center justify-center flex-shrink-0 w-4 h-4 mt-0.5 rounded-full;
  @apply bg-feedback-positive-pure text-neutral-high-pure;
}

.condition-check-icon {
  @apply w-[11px] h-[11px];
}
</style>
